function isInvoiceCarrierValid(invoiceCarrier) {
    // 檢查手機載具規則
    // 第一碼限制為「/」
    // 後面7碼為數字0 - 9、大寫英文A - Z、+、-、.
    const pattern = /^\/[0-9A-Z+-.]{7}$/;
    if (pattern.test(invoiceCarrier)) {
        return true;
    } else {
        return false;
    }
}

function isVatNumberValid(vatNumber) {
    // 統編驗證
    let taxNumberString = vatNumber.toString();
    const cx = [1, 2, 1, 2, 1, 2, 4, 1];
    if (taxNumberString.length !== 8) {
        console.log("統編長度錯誤");
        return false;
    }
    let sum = 0;
    let taxNumberArray = taxNumberString.split("");

    taxNumberArray.forEach((item, index) => {
        sum += countTotal(item * cx[index]);
    });
    if (sum % 10 === 0) {
        return true;
    } else if (sum % 5 == 0) {
        return true;
    } else if (taxNumberArray[6] === "7" && (sum + 1) % 10 === 0) {
        return true;
    } else {
        return false;
    }
}

function countTotal(num) {
    let total = num;
    if (total > 9) {
        let s = total.toString();
        const n1 = s.substring(0, 1) * 1;
        const n2 = s.substring(1, 2) * 1;
        total = n1 + n2;
    }
    return total;
}

function isNpoBanValid(npoBan) {
    // 檢查愛心碼
    const pattern = /^\d{3,7}$/;
    return pattern.test(npoBan);
}

function isValidEmail(email) {
    // 使用正規表達式檢查 email 格式
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
}

function isValidPhoneNumber(phone) {
    // 使用正規表達式檢查台灣手機號碼格式
    const phoneNumberPattern = /^09\d{8}$/;
    return phoneNumberPattern.test(phone);
}

function isValidNumber(number) {
    // 檢查是否為數字
    const NumberPattern = /\d{3}$/;
    return NumberPattern.test(number);
}

export default {
    isInvoiceCarrierValid,
    isVatNumberValid,
    isNpoBanValid,
    isValidEmail,
    // Add By Bryant 2025/08/25 Begin
    isValidNumber,
    // Add By Bryant 2025/08/25 End
    isValidPhoneNumber
}